export const tertiaryHoverSx = (theme) => ({
  '&:hover': {
    color: theme.palette.tertiary.main,
  },
});

export const buttonSx = (theme) => ({
  color: theme.palette.default.main,
  backgroundColor: theme.palette.tertiary.main,
  '&:hover': {
    backgroundColor: theme.palette.quaternary.main,
  },
});

export const flexCenterSx = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

export const marginRight12Sx = { marginRight: '12px' };

export const marginTop16Sx = {
  marginTop: '16px',
};

export const centerTextSx = {
  textAlign: 'center',
};

export const centerText15pxMarginSx = {
  textAlign: 'center',
  margin: '15px',
};

export const font900Sx = {
  fontWeight: '900',
};

export const containerSx = {
  display: 'flex',
  alignItems: 'center',
  marginBottom: '32px',
};

export const boxContainerSx = {
  width: '100%',
  overflow: 'hidden',
  flexDirection: 'column',
  ...flexCenterSx,
};

export const marginTop24Sx = { marginTop: '24px' };
export const marginBottom24Sx = { marginBottom: '24px' };

export const formInputSx = (theme) => ({
  '& .MuiOutlinedInput-root': {
    color: theme.palette.secondary.main,
    '& fieldset': {
      borderColor: theme.palette.secondary.main,
      color: theme.palette.secondary.main,
    },
    '&:hover fieldset': {
      borderColor: theme.palette.tertiary.main,
      color: theme.palette.secondary.main,
    },
    '&.Mui-focused fieldset': {
      color: theme.palette.secondary.main,
    },
    '& ::-webkit-calendar-picker-indicator': {
      filter: 'invert(1)',
    },
  },
});

export const inputLabelPropsSx = (theme, isDisableLabel) => ({
  style: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    width: '100%',
    color: theme.palette.secondary.main,
    fontWeight: 700,
  },
  shrink: isDisableLabel,
});

export const noActivitiesContainerSx = {
  ...flexCenterSx,
  padding: '24px',
};

export const mediaCardSx = (theme) => ({
  maxWidth: '345px',
  minWidth: '345px',
  backgroundColor: theme.palette.background.secondary,
  flex: '0 0 50%',
  margin: '16px',
  borderRadius: '2.5%',
});

export const mediaCardHeaderSx = (theme) => ({
  color: `${theme.palette.secondary.main} !important`,
});

export const mediaCardTypographySx = {
  style: {
    fontSize: '20px',
  },
};

export const mediaContainerSx = (isMobile) => ({
  ...flexCenterSx,
  flexDirection: isMobile ? 'column' : 'row',
  marginBottom: '80px',
  flexFlow: 'row wrap',
});

export const marginBottom16Sx = { marginBottom: '16px' };

export const iconLinkSx = (theme) => ({
  color: theme.palette.secondary.main,
  margin: 'auto 16px',
  cursor: 'pointer',
  ...tertiaryHoverSx(theme),
  [theme.breakpoints.up('xs')]: {
    fontSize: '24px',
    margin: 'auto 8px',
  },
  [theme.breakpoints.up('sm')]: {
    fontSize: '24px',
    margin: 'auto 8px',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '32px',
    margin: 'auto 12px',
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '32px',
    margin: 'auto 12px',
  },
});
